<script lang="ts">
  import AlertCircle from '../../../assets/svgs/alert-circle.svelte';
  export let placeholder: string;
  export let name = '';
  export let customClass = '';
  export let customInputClass = '';
  export let handleKeydown: ((...args: any[]) => Promise<void>) | null = null;

  export let value: string = '';
  export let errorMessage: string = '';
  export let success: boolean = false;

  $: borderColor = errorMessage ? 'border-error-500' : 'border-gray-300';
  $: textColor = success
    ? 'text-gray-300 placeholder:text-gray-400'
    : 'text-gray-900 placeholder:text-gray-500';
</script>

<div class="w-full flex flex-col {customClass}">
  <div class="relative flex flex-col">
    <slot name="beforeInput" />
    <input
      type="text"
      {name}
      bind:value
      {placeholder}
      disabled={success}
      on:input={() => {
        errorMessage = '';
      }}
      class="py-2.5 px-3.5 border {borderColor} bg-white rounded-lg {textColor} {customInputClass}"
      {...$$restProps}
      on:keydown={handleKeydown}
    />
    <slot name="afterInput" />
    {#if errorMessage}
      <div class="absolute top-2/4 right-3 grid -translate-y-2/4 place-items-center">
        <AlertCircle />
      </div>
    {/if}
  </div>
  {#if errorMessage}
    <p class="text-error-500 text-sm font-normal mt-1.5">{errorMessage}</p>
  {/if}
</div>
